import React from "react";
import {Container} from "reactstrap";
import {inject, observer} from "mobx-react";
import GenericTableAffichage from "../../../components/Akitatek/Table/GenericTableAffichage";


const PriseEnCharge = (inject("rootStore")(observer(class PriseEnCharge extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.injected.rootStore.savedDatasStore.setHeader("Prises En Charge", "Gérer les Prises En Charge", "tools.jpg", this.injected.rootStore.prisenchargeStore)
    }

    get injected() {
        return this.props;
    }

    // À l'ouverture de la liste, ou au clic sur son accueil quand on y est déjà : retour au filtre « En cours ».
    componentDidMount() {
        // Liste vide : le tableau la charge lui-même avec le filtre par défaut.
        const store = this.injected.rootStore.prisenchargeStore
        store.filtreParDefaut(store.datas.length > 0)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location?.key !== this.props.location?.key) {
            this.injected.rootStore.prisenchargeStore.filtreParDefaut()
        }
    }


    render() {
        return (
            <>
                <Container className="mt-2" fluid>
                    <GenericTableAffichage api={this.injected.rootStore.prisenchargeStore}
                                           user={false}
                                           status={true}
                                           statusHeader={true}
                                           priseencharge={true}
                                           icon={<i className="fa fa-briefcase mr-2" aria-hidden="true"/>}
                                           name={"Prises en Charge"}
                                           type="pec"/>
                </Container>
            </>
        );
    }
})));

export default PriseEnCharge;
